import * as React from 'react';
import { ISelectOption } from '../../../../../web/components/DeprecatedSelect';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../../../web/components-v2/Select';
import { styleSheet } from './styles';

interface IProps {
	disabled?: boolean;
	onChange?: (item: string) => void;
	selected?: string;
}

const options: ISelectOption<string>[] = [
	{
		dataContext: null,
		id: 'all',
		text: 'All Channels',
	},
	{
		dataContext: '1',
		id: '1',
		text: 'Rep Only',
	},
	{
		dataContext: '2',
		id: '2',
		text: 'All Parties',
	},
];

export const RecordingChannelsSelect: React.FC<IProps> = ({ disabled, onChange, selected }) => {
	const selectedOption = options.find(x => x.dataContext === selected) || options[0];

	return (
		<Select
			disabled={disabled}
			value={selectedOption?.id}
			onValueChange={id => {
				const option = options.find(o => o.id === id);
				if (option) onChange?.(option.dataContext);
			}}
		>
			<SelectTrigger styles={styleSheet.select}>
				<span>{selectedOption?.text ?? 'Select...'}</span>
			</SelectTrigger>
			<SelectContent styles={styleSheet.selectDropdown}>
				{options.map(option => (
					<SelectItem key={option.id} value={option.id} styles={styleSheet.selectItem}>
						{option.text}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
